import {SET_SPARES_BUSINESS_TYPE_LIST} from "../../Actions/ActionConstants";

const BusinessTypeListReducer = (state = null, action) => {
    if (action.type === SET_SPARES_BUSINESS_TYPE_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default BusinessTypeListReducer
